<div class="dashboard-pdf-view-layout">
    <div class="dashboard-pdf-view-layout-container" [ngClass]="{'collapsed': dashboardCollapsed}">

        <div *ngIf="container" class="dashboard-pdf-layout-item"
             [style.width]="container.offsetWidth + 'px'">
            <html-editable-renderer [(htmlCode)]="headerHtmlCode"
                                    [(cssStyles)]="headerCssStyles"
                                    [containerClass]="dashboardHeaderClass"
                                    editionDialogHeader="Edit Header"
                                    editionButtonHint="Edit header">
            </html-editable-renderer>
        </div>

        <div #container class="dashboard-pdf-preview dashboard-pdf-layout-item"
             (click)="changeDashboardPreviewVisibility($event)">
            <reporting-dashboard [dashboardView]="dashboardView"
                                 [renderHeaderAndFooter]="false"
                                 [collapsed]="dashboardCollapsed"
                                 output="PDF">
            </reporting-dashboard>
        </div>

        <div *ngIf="container" class="dashboard-pdf-layout-item"
             [style.width]="container.offsetWidth + 'px'">
            <html-editable-renderer [(htmlCode)]="footerHtmlCode"
                                    [(cssStyles)]="footerCssStyles"
                                    [containerClass]="dashboardFooterClass"
                                    editionDialogHeader="Edit Footer"
                                    editionButtonHint="Edit footer">
            </html-editable-renderer>
        </div>

    </div>
</div>